import store from "@/store/index";

export default (router, i18n) => {
  router.beforeEach((to, from, next) => {
    const titleKey = to.meta.title || "App Follower";
    const translatedTitle = i18n.global.t(titleKey); 
    store.dispatch('pageTitle/updatePageTitle', translatedTitle);
    document.title = translatedTitle;
    next();
  });
};
